"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwaEmptyWidget = bwaEmptyWidget;
var _utils = require("../../../utils/utils");
var _constants = require("../../../constants/constants");
function bwaEmptyWidget(id, cssClass) {
  return (0, _utils.generateIframe)(id, cssClass, _constants.WIDGET_ENDPOINTS.EMPTY_WIDGET);
}
//# sourceMappingURL=bwa-empty-widget.js.map
